import React from "react";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import PasswordGenerator from "Components/PasswordGenerator";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";
import ApiTokenGenerator from "Components/apiTokenGenerator/ApiTokenGenerator";
import { t } from "i18next";
import cx from "classnames";
import s from "./securityCustomers.scss";

export default class Security extends React.Component {
  state = {
    viewFields: ["password", "password_confirmation"],
  };

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  fillPasswordFields = (generatedPassword) => {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword,
    });
  };

  render() {
    const {
      formErrors,
      formData,
      isFormLoading,
      setFormFieldValue,
      submitForm,
      customer,
      generateApiToken,
      destroyApiToken,
      apiToken,
      isGeneratingToken,
      isResettingToken,
      apiTokenResetted,
      adminVersion,
    } = this.props;

    return (
      <form className={s.security} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>
          <div className={s.infoBtnGroup}>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.password.title")}</div>
              <div className="sectionDesc">
                {adminVersion
                  ? t("settings.sections.password.desc.admin")
                  : t("settings.sections.password.desc.customer")}
              </div>
            </div>
            <div className="formsSectionSP">
              <Input
                className="inputFull2"
                label={t("input.label.password.new")}
                name="password"
                value={formData.password}
                onChange={setFormFieldValue}
                errors={formErrors.password}
                type="password"
                required
              />

              <Input
                className="inputFull2"
                label={t("input.label.passwordConfirm.new")}
                name="password_confirmation"
                value={formData.password_confirmation}
                onChange={setFormFieldValue}
                errors={formErrors.password_confirmation}
                type="password"
                required
              />

              <PasswordGenerator className="inputFull2" onNewPassword={this.fillPasswordFields} />
            </div>
          </div>

          {!adminVersion && (
            <div className="sectionSP">
              <div className="infoSectionSP">
                <div className="settingTitle">{t("settings.sections.api.title")}</div>
                <div className="sectionDesc">{t("settings.sections.api.desc.customer")}</div>
              </div>
              <div className="formsSectionSP">
                <ApiTokenGenerator
                  className="inputFull2"
                  token={apiToken || (!apiTokenResetted && customer.api_token)}
                  generate={() => generateApiToken(customer.code)}
                  destroy={() => destroyApiToken(customer.code)}
                  loading={isGeneratingToken}
                  resetting={isResettingToken}
                />
              </div>
            </div>
          )}
        </div>
      </form>
    );
  }
}
